import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createEodManifestForAll = {
  name: "createEodManifestForAll" as const,
  input: z.object({ carrier: createEnum(Carriers), addressName: z.string() }),
  output: z.object({ success: z.boolean() }),
};
